(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ef-home-hero"] && !Shopify.designMode) return;
  try {
    
  function initHomeVideos(root) {
    root.querySelectorAll('[data-ef-home-video]').forEach(function (media) {
      if (media.dataset.ready) return;
      media.dataset.ready = 'true';
      var video = media.querySelector('video');
      if (!video) return;
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var connection = navigator.connection;
      var visible = false;
      var framing = (media.dataset.videoFraming || '').split(',').map(function (entry) {
        var parts = entry.split(':').map(Number);
        return { time: parts[0], y: parts[1] };
      }).filter(function (frame) { return Number.isFinite(frame.time) && Number.isFinite(frame.y) && frame.time >= 0 && frame.y >= 0 && frame.y <= 100; }).sort(function (a, b) { return a.time - b.time; });
      var currentFocus;
      function frameVideo() {
        var frame = framing.filter(function (frame) { return frame.time <= video.currentTime; }).pop();
        var next = framing.find(function (frame) { return frame.time > video.currentTime; });
        if (!frame) return;
        var focus = next ? frame.y + (next.y - frame.y) * (video.currentTime - frame.time) / (next.time - frame.time) : frame.y;
        focus = Math.round(focus * 100) / 100;
        if (focus !== currentFocus) { currentFocus = focus; video.style.setProperty('--ef-video-focus', focus + '%'); }
      }
      video.addEventListener('timeupdate', frameVideo);
      video.addEventListener('seeking', frameVideo);
      if (framing.length && video.requestVideoFrameCallback) {
        video.requestVideoFrameCallback(function followFrame() { frameVideo(); video.requestVideoFrameCallback(followFrame); });
      }
      video.muted = true;
      video.controls = false;
      function play() {
        var result = video.play();
        if (result) result.catch(function () { /* Keep the poster when autoplay is unavailable. */ });
      }
      function sync() {
        if (!visible || document.hidden || motion.matches || (connection && connection.saveData)) video.pause();
        else play();
      }
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', sync);
      if (connection) connection.addEventListener('change', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.15 }).observe(media);
      } else { visible = true; sync(); }
    });
  }
  initHomeVideos(document);
  document.addEventListener('shopify:section:load', function (event) { initHomeVideos(event.target); });

  } catch(e) { console.error(e); }
})();
})();
